import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  HStack,
  useToast,
  Spinner,
  Center,
} from "@chakra-ui/react";
import {
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import { supabase } from "../lib/supabaseClient";

const Label = () => {
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 10;
  const toast = useToast();

  const fetchLabels = async () => {
    try {
      setLoading(true);

      // 검색 조건에 따른 쿼리 생성
      let query = supabase
        .from("label")
        .select("*", { count: "exact" })
        .ilike("name", `%${searchTerm}%`);

      // 페이지네이션 적용
      const from = (currentPage - 1) * itemsPerPage;
      const to = from + itemsPerPage - 1;

      const { data, error, count } = await query
        .range(from, to)
        .order("created_date_formatted", { ascending: false });

      if (error) throw error;

      setLabels(data || []);
      setTotalCount(count || 0);
    } catch (error) {
      console.error("Error fetching labels:", error);
      toast({
        title: "데이터 로딩 실패",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLabels();
  }, [currentPage, searchTerm]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // 검색 시 첫 페이지로 이동
  };

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  return (
    <Container maxW="container.xl" py={10}>
      <Box bg="white" p={6} borderRadius="xl" boxShadow="lg">
        <InputGroup mb={6}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.300" />
          </InputLeftElement>
          <Input
            placeholder="레이블 검색..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </InputGroup>

        {loading ? (
          <Center p={10}>
            <Spinner size="xl" />
          </Center>
        ) : (
          <>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>이름</Th>
                  <Th>설명</Th>
                  <Th>생성일</Th>
                </Tr>
              </Thead>
              <Tbody>
                {labels.map((label) => (
                  <Tr key={label.uuid}>
                    <Td>{label.name}</Td>
                    <Td>{label.description}</Td>
                    <Td>
                      {new Date(
                        label.created_date_formatted
                      ).toLocaleDateString()}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>

            <HStack justify="center" mt={6}>
              <Button
                leftIcon={<ChevronLeftIcon />}
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                isDisabled={currentPage === 1}
              >
                이전
              </Button>
              <Button
                rightIcon={<ChevronRightIcon />}
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                isDisabled={currentPage === totalPages}
              >
                다음
              </Button>
            </HStack>
          </>
        )}
      </Box>
    </Container>
  );
};

export default Label;
